module.exports = __webpack_public_path__ + "img/ic_down_20.dc9a4976.svg";